const ptBR = {
  metaTitle: 'Marketing Digital Profissional | WSJ Soluções Digitais',
  badge: 'Marketing Digital',
  heroTitle: 'Sua empresa precisa existir profissionalmente no digital.',
  heroSubtitle:
    'A WSJ ajuda negócios a criarem presença digital organizada, profissional e preparada para gerar confiança e oportunidades.',
  heroBadges: [
    'Google Meu Negócio',
    'Instagram Business',
    'Facebook Business',
    'TikTok Business',
    'WhatsApp Business',
    'Linktree',
    'Posts profissionais',
    'Estratégia digital'
  ],
  btnQuote: 'Solicitar orçamento',
  btnWhatsapp: 'Falar no WhatsApp',
  btnServices: 'Ver serviços',
  whatsappMessage: 'Olá! Gostaria de um orçamento para marketing digital com a WSJ.',

  sectionProblemsTitle: 'O que prejudica muitas empresas no digital?',
  sectionProblemsClose:
    'A WSJ organiza sua presença digital para transmitir confiança, profissionalismo e clareza.',
  problemItems: [
    { title: 'Perfil desorganizado', desc: 'Informações soltas, visual inconsistente e pouca clareza sobre o que a empresa faz.' },
    { title: 'Falta de identidade visual', desc: 'Cores, fontes e estilo diferentes em cada canal — a marca parece amadora.' },
    { title: 'Google mal configurado', desc: 'Empresa invisível ou mal apresentada nas buscas locais e no Google Maps.' },
    { title: 'Redes abandonadas', desc: 'Perfis parados, sem atualização e sem estratégia — passam desconfiança.' },
    { title: 'WhatsApp sem profissionalismo', desc: 'Atendimento confuso, bio incompleta e catálogo desorganizado.' },
    { title: 'Pouca confiança online', desc: 'Visitantes não encontram prova de seriedade antes de entrar em contato.' },
    { title: 'Conteúdo inconsistente', desc: 'Posts sem padrão visual, sem frequência e sem direção estratégica.' },
    { title: 'Comunicação confusa', desc: 'Mensagens diferentes em cada canal — o cliente não entende a proposta.' }
  ],

  sectionChannelsTitle: 'Uma presença digital profissional em todos os canais',
  sectionChannelsLead: 'Organizamos cada ponto de contato digital da sua empresa com padrão, clareza e visual premium.',
  channels: [
    { title: 'Google Meu Negócio', desc: 'Configuração profissional para aparecer bem no Google e no Maps.' },
    { title: 'Instagram Business', desc: 'Perfil organizado, bio clara e estrutura visual profissional.' },
    { title: 'Facebook Business', desc: 'Página configurada com informações, contatos e identidade alinhada.' },
    { title: 'TikTok Business', desc: 'Presença preparada para conteúdo e descoberta no formato certo.' },
    { title: 'WhatsApp Business', desc: 'Atendimento profissional com catálogo, links e organização.' },
    { title: 'Linktree personalizado', desc: 'Hub de links com visual da marca e navegação objetiva.' },
    { title: 'Catálogo WhatsApp', desc: 'Produtos e serviços apresentados de forma clara para vender melhor.' },
    { title: 'Bio profissional', desc: 'Texto estratégico que explica quem você é e o que oferece.' },
    { title: 'Estratégia visual', desc: 'Padrão de cores, estilo e comunicação em todos os canais.' },
    { title: 'Organização de destaques', desc: 'Stories fixos organizados por tema, serviço ou prova social.' },
    { title: 'Configuração de contatos', desc: 'Botões, links e CTAs corretos em cada plataforma.' },
    { title: 'Padronização visual', desc: 'Marca coerente em posts, capas, perfis e materiais digitais.' }
  ],

  sectionSupportTitle: 'Você pode contratar apenas a estrutura ou continuar com suporte mensal.',
  supportSetupTitle: 'Estrutura inicial',
  supportSetupDesc:
    'Configuramos sua presença digital profissional e entregamos tudo organizado para sua empresa operar.',
  supportSetupBadge: 'Pagamento único',
  supportSetupItems: [
    'Configuração dos perfis',
    'Organização visual',
    'Bio profissional',
    'Links',
    'WhatsApp Business',
    'Google Meu Negócio',
    'Estrutura inicial'
  ],
  supportOngoingTitle: 'Suporte contínuo',
  supportOngoingDesc:
    'Acompanhamos sua operação digital com suporte, atualizações e auxílio contínuo.',
  supportOngoingBadge: 'Mais contratado',
  supportOngoingItems: [
    'Suporte mensal',
    'Atualização de informações',
    'Criação de posts',
    'Ajustes visuais',
    'Acompanhamento',
    'Organização contínua',
    'Apoio estratégico'
  ],

  sectionProcessTitle: 'Como funciona',
  sectionProcessLead: 'Um processo claro para profissionalizar sua presença digital com acompanhamento WSJ.',
  processSteps: [
    { title: 'Entendemos seu negócio', desc: 'Mapeamos objetivos, público, canais e o que precisa ser organizado.' },
    { title: 'Organizamos sua estrutura digital', desc: 'Definimos padrão visual, mensagens, links e prioridades por canal.' },
    { title: 'Configuramos os canais', desc: 'Google, redes sociais, WhatsApp, Linktree e demais pontos de contato.' },
    { title: 'Sua empresa começa a operar com mais profissionalismo', desc: 'Entrega organizada, orientação e suporte para manter consistência.' }
  ],

  sectionPlansTitle: 'Planos para profissionalizar sua presença digital',
  sectionPlansLead: 'Estrutura, suporte e estratégia para sua marca existir com autoridade no digital.',
  plansBillingMonthly: 'Mensal',
  plansBillingAnnual: 'Anual',
  plansSaveBadge: 'Economize 17%',
  plansDisclaimer:
    'Projetos com gestão avançada de tráfego pago, campanhas complexas ou produção intensiva de conteúdo podem exigir orçamento personalizado.',
  planStartName: 'Digital Start',
  planStartDesc: 'Ideal para empresas que precisam organizar sua presença digital.',
  planStartFeatures: [
    'Google Meu Negócio',
    'Instagram Business',
    'Facebook Business',
    'WhatsApp Business',
    'Bio profissional',
    'Linktree personalizado',
    'Organização visual inicial',
    'Suporte básico'
  ],
  planStartCta: 'Começar estrutura',
  planGrowthName: 'Digital Growth',
  planGrowthBadge: 'Mais popular',
  planGrowthDesc: 'Ideal para empresas que querem presença digital mais forte e acompanhamento.',
  planGrowthFeatures: [
    'Tudo do Start',
    'Criação de posts',
    'Atualizações mensais',
    'Organização contínua',
    'Estratégia visual',
    'Suporte prioritário',
    'Catálogo WhatsApp',
    'Organização de destaques',
    'Apoio estratégico'
  ],
  planGrowthCta: 'Começar agora',
  planPremiumName: 'Digital Premium',
  planPremiumBadge: 'Premium',
  planPremiumDesc: 'Ideal para empresas que precisam de acompanhamento mais completo e estrutura profissional contínua.',
  planPremiumFeatures: [
    'Estratégia personalizada',
    'Gestão visual contínua',
    'Criação de conteúdo',
    'Organização completa',
    'Suporte prioritário',
    'Acompanhamento próximo',
    'Estrutura multi-canal',
    'Consultoria digital',
    'Atendimento dedicado'
  ],
  planPremiumCta: 'Falar com especialista',

  sectionRealProjectsTitle: 'Empresas que confiaram na WSJ',
  sectionRealProjectsLead: 'Alguns projetos e estruturas digitais desenvolvidos pela WSJ.',
  realProjectsVisitCta: 'Visitar site',
  realProjectBadgeInstitutional: 'Institucional',
  realProjectBadgeEcommerce: 'E-commerce',
  realProjects: [
    {
      name: 'BENCOAÇO',
      url: 'https://bencoaco.com.br/',
      category: 'Presença digital',
      badge: 'institutional',
      desc: 'Site institucional e presença digital profissional para fortalecer autoridade e confiança da marca.',
      logo: '/assets/clients/bencoaco.png',
      previewGradient: 'from-blue-600/30 via-sky-900/15 to-slate-950/50'
    },
    {
      name: 'SOETO',
      url: 'https://www.soeto.com.br/',
      category: 'Operação digital',
      badge: 'ecommerce',
      desc: 'Estrutura digital completa com foco em catálogo, experiência do usuário e profissionalismo online.',
      logo: '/assets/clients/soeto.png',
      previewGradient: 'from-emerald-600/28 via-green-900/15 to-slate-950/50'
    },
    {
      name: 'CAFEGHINI',
      url: 'https://www.cafeghini.com.br/',
      category: 'Branding digital',
      badge: 'ecommerce',
      desc: 'Presença digital moderna com identidade visual premium e navegação profissional.',
      logo: '/assets/clients/cafeghini.png',
      previewGradient: 'from-rose-600/30 via-red-900/15 to-slate-950/50'
    }
  ],

  sectionFaqTitle: 'Perguntas frequentes',
  sectionFaqLead: 'Transparência total antes de investir na sua presença digital.',
  faqItems: [
    {
      q: 'Vocês criam Google Meu Negócio?',
      a: 'Sim. Configuramos e organizamos seu perfil no Google para aparecer com informações corretas, visual profissional e melhor presença local.'
    },
    {
      q: 'Vocês configuram WhatsApp Business?',
      a: 'Sim. Organizamos bio, catálogo, links, mensagens e estrutura de atendimento para transmitir profissionalismo.'
    },
    {
      q: 'A WSJ cria posts também?',
      a: 'Sim. Nos planos Growth e Premium incluímos criação e organização de conteúdo conforme o escopo contratado.'
    },
    {
      q: 'Vocês fazem suporte mensal?',
      a: 'Sim. Oferecemos acompanhamento contínuo com atualizações, ajustes visuais, posts e apoio estratégico.'
    },
    {
      q: 'Posso contratar apenas a estrutura inicial?',
      a: 'Sim. Você pode contratar apenas a configuração inicial e operar por conta própria, ou evoluir para suporte mensal depois.'
    },
    {
      q: 'Vocês ajudam com Instagram e Facebook?',
      a: 'Sim. Configuramos perfis, bios, links, destaques, padrão visual e organização profissional em ambas as plataformas.'
    },
    {
      q: 'O Linktree fica personalizado?',
      a: 'Sim. Criamos um hub de links com visual alinhado à sua marca, não um template genérico.'
    },
    {
      q: 'Posso começar pequeno e evoluir depois?',
      a: 'Sim. Nossos planos permitem começar com estrutura essencial e evoluir conforme sua operação digital cresce.'
    }
  ],

  finalCtaTitle: 'Pronto para profissionalizar sua presença digital?',
  finalCtaSubtitle:
    'A WSJ ajuda sua empresa a transmitir mais confiança, organização e profissionalismo no digital.',

  heroMock: {
    instagramLabel: 'Instagram',
    googleLabel: 'Google Meu Negócio',
    whatsappLabel: 'WhatsApp Business',
    linktreeLabel: 'Linktree',
    insightsLabel: 'Social Insights',
    metric: '+62%',
    live: 'Ao vivo'
  }
};

const ptPT = {
  ...ptBR,
  heroSubtitle:
    'A WSJ ajuda negócios a criarem presença digital organizada, profissional e preparada para gerar confiança e oportunidades.',
  sectionProblemsClose:
    'A WSJ organiza a sua presença digital para transmitir confiança, profissionalismo e clareza.',
  sectionChannelsLead: 'Organizamos cada ponto de contacto digital da sua empresa com padrão, clareza e visual premium.',
  problemItems: [
    { title: 'Perfil desorganizado', desc: 'Informações soltas, visual inconsistente e pouca clareza sobre o que a empresa faz.' },
    { title: 'Falta de identidade visual', desc: 'Cores, fontes e estilo diferentes em cada canal — a marca parece amadora.' },
    { title: 'Google mal configurado', desc: 'Empresa invisível ou mal apresentada nas pesquisas locais e no Google Maps.' },
    { title: 'Redes abandonadas', desc: 'Perfis parados, sem atualização e sem estratégia — passam desconfiança.' },
    { title: 'WhatsApp sem profissionalismo', desc: 'Atendimento confuso, bio incompleta e catálogo desorganizado.' },
    { title: 'Pouca confiança online', desc: 'Visitantes não encontram prova de seriedade antes de entrar em contacto.' },
    { title: 'Conteúdo inconsistente', desc: 'Posts sem padrão visual, sem frequência e sem direção estratégica.' },
    { title: 'Comunicação confusa', desc: 'Mensagens diferentes em cada canal — o cliente não entende a proposta.' }
  ],
  realProjects: [
    {
      name: 'BENCOAÇO',
      url: 'https://bencoaco.com.br/',
      category: 'Presença digital',
      badge: 'institutional',
      desc: 'Site institucional e presença digital profissional para reforçar autoridade e confiança da marca.',
      logo: '/assets/clients/bencoaco.png',
      previewGradient: 'from-blue-600/30 via-sky-900/15 to-slate-950/50'
    },
    {
      name: 'SOETO',
      url: 'https://www.soeto.com.br/',
      category: 'Operação digital',
      badge: 'ecommerce',
      desc: 'Estrutura digital completa com foco em catálogo, experiência do utilizador e profissionalismo online.',
      logo: '/assets/clients/soeto.png',
      previewGradient: 'from-emerald-600/28 via-green-900/15 to-slate-950/50'
    },
    {
      name: 'CAFEGHINI',
      url: 'https://www.cafeghini.com.br/',
      category: 'Branding digital',
      badge: 'ecommerce',
      desc: 'Presença digital moderna com identidade visual premium e navegação profissional.',
      logo: '/assets/clients/cafeghini.png',
      previewGradient: 'from-rose-600/30 via-red-900/15 to-slate-950/50'
    }
  ],
  faqItems: [
    {
      q: 'Criam Google Meu Negócio?',
      a: 'Sim. Configuramos e organizamos o seu perfil no Google para aparecer com informações corretas, visual profissional e melhor presença local.'
    },
    {
      q: 'Configuram WhatsApp Business?',
      a: 'Sim. Organizamos bio, catálogo, links, mensagens e estrutura de atendimento para transmitir profissionalismo.'
    },
    {
      q: 'A WSJ cria posts também?',
      a: 'Sim. Nos planos Growth e Premium incluímos criação e organização de conteúdo conforme o âmbito contratado.'
    },
    {
      q: 'Fazem suporte mensal?',
      a: 'Sim. Oferecemos acompanhamento contínuo com atualizações, ajustes visuais, posts e apoio estratégico.'
    },
    {
      q: 'Posso contratar apenas a estrutura inicial?',
      a: 'Sim. Pode contratar apenas a configuração inicial e operar por conta própria, ou evoluir para suporte mensal depois.'
    },
    {
      q: 'Ajudam com Instagram e Facebook?',
      a: 'Sim. Configuramos perfis, bios, links, destaques, padrão visual e organização profissional em ambas as plataformas.'
    },
    {
      q: 'O Linktree fica personalizado?',
      a: 'Sim. Criamos um hub de links com visual alinhado à sua marca, não um template genérico.'
    },
    {
      q: 'Posso começar pequeno e evoluir depois?',
      a: 'Sim. Os nossos planos permitem começar com estrutura essencial e evoluir conforme a operação digital cresce.'
    }
  ],
  finalCtaSubtitle:
    'A WSJ ajuda a sua empresa a transmitir mais confiança, organização e profissionalismo no digital.'
};

const enUS = {
  metaTitle: 'Professional Digital Marketing | WSJ Soluções Digitais',
  badge: 'Digital Marketing',
  heroTitle: 'Your business needs to exist professionally online.',
  heroSubtitle:
    'WSJ helps businesses build organised, professional digital presence ready to generate trust and opportunities.',
  heroBadges: [
    'Google Business Profile',
    'Instagram Business',
    'Facebook Business',
    'TikTok Business',
    'WhatsApp Business',
    'Linktree',
    'Professional posts',
    'Digital strategy'
  ],
  btnQuote: 'Request a quote',
  btnWhatsapp: 'Talk on WhatsApp',
  btnServices: 'View services',
  whatsappMessage: 'Hello! I would like a quote for digital marketing with WSJ.',

  sectionProblemsTitle: 'What hurts many businesses online?',
  sectionProblemsClose: 'WSJ organises your digital presence to convey trust, professionalism and clarity.',
  problemItems: [
    { title: 'Disorganised profile', desc: 'Scattered information, inconsistent visuals and unclear messaging about what you do.' },
    { title: 'No visual identity', desc: 'Different colours, fonts and styles on each channel — the brand looks amateur.' },
    { title: 'Poor Google setup', desc: 'Business invisible or poorly presented in local search and Google Maps.' },
    { title: 'Abandoned social media', desc: 'Inactive profiles with no updates or strategy — they erode trust.' },
    { title: 'Unprofessional WhatsApp', desc: 'Confusing support, incomplete bio and disorganised catalogue.' },
    { title: 'Low online trust', desc: 'Visitors find no proof of credibility before reaching out.' },
    { title: 'Inconsistent content', desc: 'Posts without visual standards, frequency or strategic direction.' },
    { title: 'Confusing communication', desc: 'Different messages on each channel — customers don\'t understand your offer.' }
  ],

  sectionChannelsTitle: 'Professional digital presence across every channel',
  sectionChannelsLead: 'We organise every digital touchpoint with standards, clarity and premium visuals.',
  channels: [
    { title: 'Google Business Profile', desc: 'Professional setup to appear well on Google and Maps.' },
    { title: 'Instagram Business', desc: 'Organised profile, clear bio and professional visual structure.' },
    { title: 'Facebook Business', desc: 'Page configured with information, contacts and aligned identity.' },
    { title: 'TikTok Business', desc: 'Presence ready for content and discovery in the right format.' },
    { title: 'WhatsApp Business', desc: 'Professional support with catalogue, links and organisation.' },
    { title: 'Custom Linktree', desc: 'Link hub with brand visuals and clear navigation.' },
    { title: 'WhatsApp catalogue', desc: 'Products and services presented clearly to sell better.' },
    { title: 'Professional bio', desc: 'Strategic copy that explains who you are and what you offer.' },
    { title: 'Visual strategy', desc: 'Colour, style and communication standards across channels.' },
    { title: 'Highlights organisation', desc: 'Pinned stories organised by theme, service or social proof.' },
    { title: 'Contact setup', desc: 'Correct buttons, links and CTAs on each platform.' },
    { title: 'Visual standardisation', desc: 'Coherent brand across posts, covers, profiles and digital assets.' }
  ],

  sectionSupportTitle: 'You can hire just the setup or continue with monthly support.',
  supportSetupTitle: 'Initial setup',
  supportSetupDesc: 'We configure your professional digital presence and deliver everything organised for your business to operate.',
  supportSetupBadge: 'One-time payment',
  supportSetupItems: [
    'Profile configuration',
    'Visual organisation',
    'Professional bio',
    'Links',
    'WhatsApp Business',
    'Google Business Profile',
    'Initial structure'
  ],
  supportOngoingTitle: 'Ongoing support',
  supportOngoingDesc: 'We support your digital operation with updates, content and continuous assistance.',
  supportOngoingBadge: 'Most popular',
  supportOngoingItems: [
    'Monthly support',
    'Information updates',
    'Post creation',
    'Visual adjustments',
    'Follow-up',
    'Continuous organisation',
    'Strategic support'
  ],

  sectionProcessTitle: 'How it works',
  sectionProcessLead: 'A clear process to professionalise your digital presence with WSJ follow-up.',
  processSteps: [
    { title: 'We understand your business', desc: 'We map goals, audience, channels and what needs organising.' },
    { title: 'We organise your digital structure', desc: 'Visual standards, messaging, links and channel priorities.' },
    { title: 'We configure the channels', desc: 'Google, social media, WhatsApp, Linktree and other touchpoints.' },
    { title: 'Your business operates more professionally', desc: 'Organised delivery, guidance and support to stay consistent.' }
  ],

  sectionPlansTitle: 'Plans to professionalise your digital presence',
  sectionPlansLead: 'Structure, support and strategy for your brand to exist with authority online.',
  plansBillingMonthly: 'Monthly',
  plansBillingAnnual: 'Annual',
  plansSaveBadge: 'Save 17%',
  plansDisclaimer:
    'Projects with advanced paid traffic management, complex campaigns or intensive content production may require a custom quote.',
  planStartName: 'Digital Start',
  planStartDesc: 'Ideal for businesses that need to organise their digital presence.',
  planStartFeatures: [
    'Google Business Profile',
    'Instagram Business',
    'Facebook Business',
    'WhatsApp Business',
    'Professional bio',
    'Custom Linktree',
    'Initial visual organisation',
    'Basic support'
  ],
  planStartCta: 'Start setup',
  planGrowthName: 'Digital Growth',
  planGrowthBadge: 'Most popular',
  planGrowthDesc: 'Ideal for businesses that want stronger digital presence and ongoing support.',
  planGrowthFeatures: [
    'Everything in Start',
    'Post creation',
    'Monthly updates',
    'Continuous organisation',
    'Visual strategy',
    'Priority support',
    'WhatsApp catalogue',
    'Highlights organisation',
    'Strategic support'
  ],
  planGrowthCta: 'Get started',
  planPremiumName: 'Digital Premium',
  planPremiumBadge: 'Premium',
  planPremiumDesc: 'Ideal for businesses that need more complete support and continuous professional structure.',
  planPremiumFeatures: [
    'Custom strategy',
    'Continuous visual management',
    'Content creation',
    'Full organisation',
    'Priority support',
    'Close follow-up',
    'Multi-channel structure',
    'Digital consulting',
    'Dedicated account manager'
  ],
  planPremiumCta: 'Talk to a specialist',

  sectionRealProjectsTitle: 'Companies that trusted WSJ',
  sectionRealProjectsLead: 'Some projects and digital structures built by WSJ.',
  realProjectsVisitCta: 'Visit website',
  realProjectBadgeInstitutional: 'Corporate',
  realProjectBadgeEcommerce: 'E-commerce',
  realProjects: [
    {
      name: 'BENCOAÇO',
      url: 'https://bencoaco.com.br/',
      category: 'Digital presence',
      badge: 'institutional',
      desc: 'Corporate website and professional digital presence to strengthen brand authority and trust.',
      logo: '/assets/clients/bencoaco.png',
      previewGradient: 'from-blue-600/30 via-sky-900/15 to-slate-950/50'
    },
    {
      name: 'SOETO',
      url: 'https://www.soeto.com.br/',
      category: 'Digital operation',
      badge: 'ecommerce',
      desc: 'Complete digital structure focused on catalogue, user experience and online professionalism.',
      logo: '/assets/clients/soeto.png',
      previewGradient: 'from-emerald-600/28 via-green-900/15 to-slate-950/50'
    },
    {
      name: 'CAFEGHINI',
      url: 'https://www.cafeghini.com.br/',
      category: 'Digital branding',
      badge: 'ecommerce',
      desc: 'Modern digital presence with premium visual identity and professional navigation.',
      logo: '/assets/clients/cafeghini.png',
      previewGradient: 'from-rose-600/30 via-red-900/15 to-slate-950/50'
    }
  ],

  sectionFaqTitle: 'FAQ',
  sectionFaqLead: 'Full transparency before you invest in your digital presence.',
  faqItems: [
    { q: 'Do you set up Google Business Profile?', a: 'Yes. We configure and organise your Google profile with correct information, professional visuals and better local presence.' },
    { q: 'Do you configure WhatsApp Business?', a: 'Yes. We organise bio, catalogue, links, messages and support structure for a professional experience.' },
    { q: 'Does WSJ create posts too?', a: 'Yes. Growth and Premium plans include content creation and organisation according to scope.' },
    { q: 'Do you offer monthly support?', a: 'Yes. We provide ongoing follow-up with updates, visual adjustments, posts and strategic support.' },
    { q: 'Can I hire only the initial setup?', a: 'Yes. You can hire just the initial configuration and operate on your own, or upgrade to monthly support later.' },
    { q: 'Do you help with Instagram and Facebook?', a: 'Yes. We configure profiles, bios, links, highlights, visual standards and professional organisation on both platforms.' },
    { q: 'Is the Linktree customised?', a: 'Yes. We create a link hub aligned with your brand — not a generic template.' },
    { q: 'Can I start small and grow later?', a: 'Yes. Our plans let you start with essential structure and evolve as your digital operation grows.' }
  ],

  finalCtaTitle: 'Ready to professionalise your digital presence?',
  finalCtaSubtitle: 'WSJ helps your business convey more trust, organisation and professionalism online.',

  heroMock: {
    instagramLabel: 'Instagram',
    googleLabel: 'Google Business',
    whatsappLabel: 'WhatsApp Business',
    linktreeLabel: 'Linktree',
    insightsLabel: 'Social Insights',
    metric: '+62%',
    live: 'Live'
  }
};

const fallbackLocales = ['es', 'fr', 'it', 'hi', 'de', 'nl', 'ru', 'ar', 'zh-CN', 'zh-TW'];

export const marketingDigitalPageByLang = {
  'pt-BR': ptBR,
  'pt-PT': ptPT,
  en: enUS,
  ...Object.fromEntries(fallbackLocales.map((code) => [code, enUS]))
};
